import { useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { runtime } from '@/platform/runtime';
import { Toast } from '@/components/ui/Toast';

export function PwaUpdatePrompt() {
  const [needRefresh, setNeedRefresh] = useState(false);
  const { updateServiceWorker } = useRegisterSW({
    immediate: !runtime.isMiniApp,
    onNeedRefresh: () => setNeedRefresh(true),
  });
  return (
    <Toast
      open={needRefresh}
      onOpenChange={(open) => { if (!open) setNeedRefresh(false); }}
      title="Доступна новая версия"
      duration={Infinity}
      action={{ label: 'Обновить', onClick: () => updateServiceWorker(true) }}
    />
  );
}
